export const defaultOperarios = [
  { id: 'op1', nombre: 'Juan Pérez' },
  { id: 'op2', nombre: 'María García' },
  { id: 'op3', nombre: 'Carlos Ruiz' },
  { id: 'op4', nombre: 'Ana López' },
];